/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Night Life',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M9.498 4.699c-.597 1.099-.936 2.358-.936 3.695 0 4.281 3.47 7.751 7.751 7.751a7.72 7.72 0 0 0 2.74-.502c-1.332 2.254-3.783 3.765-6.588 3.765l-.394-.011c-4.044-.205-7.261-3.549-7.261-7.644 0-3.173 1.932-5.896 4.687-7.055z"
            stroke="color(display-p3 0.2000 0.2000 0.2000)"
            strokeWidth="1.2"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
